var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreFiltersMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 28,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.436 7.65a1.306 1.306 0 100 2.611 1.306 1.306 0 000-2.612zM7.245 9.47h2.034a2.218 2.218 0 004.314 0h6.71a.456.456 0 100-.91h-6.685a2.218 2.218 0 00-4.364 0h-2.01a.456.456 0 100 .91zm13.059 4.556a.456.456 0 010 .911h-2.035a2.218 2.218 0 01-4.313 0H7.245a.456.456 0 110-.911h6.686a2.218 2.218 0 014.364 0h2.009zm-2.885.395a1.306 1.306 0 10-2.612 0 1.306 1.306 0 002.612 0z",
    fill: "#fff"
  })));
}
export default SvgMoreFiltersMobile;